import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-470e7196"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-h6 text-primary q-ma-xs" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "File #:", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Date of Loss:", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "DOB:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_social_accounts_btn = _resolveComponent("social-accounts-btn")!
  const _component_bar_x_scrollable = _resolveComponent("bar-x-scrollable")!

  return (_openBlock(), _createBlock(_component_bar_x_scrollable, { class: "client-profile__details-bar" }, {
    default: _withCtx(() => [
      _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$filters.clientName(_ctx.client)), 1),
      _createElementVNode("div", null, [
        _hoisted_2,
        _createTextVNode(" " + _toDisplayString(_ctx.client.fileRefNo), 1)
      ]),
      _createElementVNode("div", null, [
        _hoisted_3,
        _createTextVNode(" " + _toDisplayString(_ctx.$filters.date(_ctx.client.dateOfLoss)), 1)
      ]),
      _createElementVNode("div", null, [
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(_ctx.$filters.date(_ctx.client.dateOfBirth)), 1)
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_social_accounts_btn, {
          "client-id": _ctx.client.id,
          flat: ""
        }, null, 8, ["client-id"])
      ])
    ]),
    _: 1
  }))
}